export function generateRandomSequence(
    length = 8,
    withLetters = true,
    withNumbers = true,
    withCharacters = true
): string {
    const chars = `${withLetters ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz' : ''}${
        withNumbers ? '0123456789' : ''
    }${withCharacters ? '!@#$%&*?' : ''}`

    let password = ''

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length)
        password += chars[randomIndex]
    }

    return password
}
